var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloverWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 29.5C22.8962 29.5 29.5 22.8962 29.5 14.75C29.5 22.8962 36.1038 29.5 44.25 29.5C36.1038 29.5 29.5 36.1038 29.5 44.25C29.5 36.1038 22.8962 29.5 14.75 29.5ZM14.75 29.5C6.6038 29.5 0 36.1038 0 44.25C0 52.3962 6.6038 59 14.75 59C22.8962 59 29.5 52.3962 29.5 44.25C29.5 52.3962 36.1038 59 44.25 59C52.3962 59 59 52.3962 59 44.25C59 36.1038 52.3962 29.5 44.25 29.5C52.3962 29.5 59 22.8962 59 14.75C59 6.6038 52.3962 0 44.25 0C36.1038 0 29.5 6.6038 29.5 14.75C29.5 6.6038 22.8962 0 14.75 0C6.6038 0 0 6.6038 0 14.75C0 22.8962 6.6038 29.5 14.75 29.5Z",
    fill: "#22D297"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverWallet);
export default __webpack_public_path__ + "static/media/cloverWallet.d121ab0e.svg";
export { ForwardRef as ReactComponent };